import __environments from '../config/environments.json';

export type Environment = 'production' | 'staging' | 'demo' | 'development';
export type DemoEnvironment = 'jade' | 'teal' | 'noir' | 'plum' | 'vert' | 'cyan' | 'opal' | 'orion';
export type SubEnvironment = Exclude<Environment, 'demo'> | DemoEnvironment;

const environments = __environments.environments as readonly Environment[];
const demoEnvironments = __environments.demoEnvironments as readonly DemoEnvironment[];
const subEnvironments = [
	...environments.filter((env) => env !== 'demo'),
	...demoEnvironments,
] as readonly SubEnvironment[];

export function getEnvironments(): readonly Environment[] {
	return environments;
}
export function getDemoEnvironments(): readonly DemoEnvironment[] {
	return demoEnvironments;
}
export function getSubEnvironments(): readonly SubEnvironment[] {
	return subEnvironments;
}
/**
 * Personalized demo environments (e.g. jlou that points to cyan) are not valid sub-environments
 */
export function isValidSubEnvironment(environment: string): environment is SubEnvironment {
	return subEnvironments.includes(environment as SubEnvironment);
}
